"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/28
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGES_INFO = exports.DOCUMENTS_INFO = exports.DATA_INFO = exports.AUDIO_VIDEO_INFO = exports.ARCHIVES_INFO = exports.ALL_ALLOWED_GROUPS = void 0;
const IMAGES_INFO = {
    MIME_TYPES: [
        "image/jpeg",
        "image/jpg", // Some systems still use this non-standard type
        "image/png",
        "image/gif",
        "image/webp",
        "image/svg+xml",
        "image/bmp",
        "image/tiff",
        "image/x-icon", // .ico files
    ],
    EXTENSIONS: [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg", ".bmp", ".tiff", ".tif", ".ico"],
};
exports.IMAGES_INFO = IMAGES_INFO;
const DOCUMENTS_INFO = {
    MIME_TYPES: [
        "application/pdf",
        "text/plain",
        "text/csv",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/rtf",
        "text/richtext",
    ],
    EXTENSIONS: [".pdf", ".txt", ".csv", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".rtf"],
};
exports.DOCUMENTS_INFO = DOCUMENTS_INFO;
const ARCHIVES_INFO = {
    MIME_TYPES: [
        "application/zip",
        "application/x-rar-compressed",
        "application/vnd.rar", // Standard MIME type for RAR
        "application/x-7z-compressed",
        "application/gzip",
        "application/x-tar",
        "application/x-bzip2",
    ],
    EXTENSIONS: [".zip", ".rar", ".7z", ".gz", ".tar", ".bz2", ".tar.gz", ".tgz"],
};
exports.ARCHIVES_INFO = ARCHIVES_INFO;
const AUDIO_VIDEO_INFO = {
    MIME_TYPES: [
        // Audio
        "audio/mpeg",
        "audio/wav",
        "audio/wave", // Alternative MIME type for WAV
        "audio/x-wav", // Legacy MIME type for WAV
        "audio/aac",
        "audio/ogg",
        "audio/webm",
        // Video
        "video/mp4",
        "video/mpeg",
        "video/quicktime",
        "video/x-msvideo", // .avi
        "video/webm",
        "video/ogg",
    ],
    EXTENSIONS: [
        // Audio
        ".mp3",
        ".wav",
        ".aac",
        ".ogg",
        ".weba",
        // Video
        ".mp4",
        ".mpeg",
        ".mpg",
        ".mov",
        ".avi",
        ".webm",
        ".ogv",
    ],
};
exports.AUDIO_VIDEO_INFO = AUDIO_VIDEO_INFO;
const DATA_INFO = {
    MIME_TYPES: ["application/json", "application/xml", "text/xml", "text/yaml", "application/x-yaml", "text/x-yaml"],
    EXTENSIONS: [".json", ".xml", ".yaml", ".yml"],
};
exports.DATA_INFO = DATA_INFO;
const ALL_ALLOWED_GROUPS = [IMAGES_INFO, DOCUMENTS_INFO, ARCHIVES_INFO, AUDIO_VIDEO_INFO, DATA_INFO];
exports.ALL_ALLOWED_GROUPS = ALL_ALLOWED_GROUPS;
//# sourceMappingURL=metadata.js.map